import { withTranslation } from 'react-i18next';
import React, { Component } from "react";
import "promise-polyfill/src/polyfill";
import Progress from "../Progress";
import i18next from "i18next";
import Api from "../../../lib/Api";
import Loader from '../../Loader';

class Experience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
      value: this.props.experience,
      flag: false
    };

    this.getExperience = this.getExperience.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.experience });
  }

  componentDidMount() {
    // scroll back to top page
    window.scrollTo(0, 0);
    // Get the data from database and store in state

    this.getExperience();

    i18next.on("languageChanged", lng => {
      this.getExperience();
    });
  }

  render() {
    if (typeof this.state.data.data !== "undefined") {
      var myArr = [];

      if (this.props.traject === "bikefit") {
        for (let v of Object.values(this.state.data.data)) {
          myArr.push([v.id, v.title, v.image, v.substep]);
        }
      } else {
        for (let v of Object.values(this.state.data.data)) {
          myArr.push([v.id, v.experience, v.intro, v.percentage]);
        }
      }

      let handleChange = this.handleChange;
      var experience = this.props.experience;

      if (this.state.value !== undefined) {
        experience = this.state.value;
      }

      var indents;
      if (this.props.traject === "bikefit") {
        indents = myArr.map(function (item, i) {
          return (
            <div key={item[0]} className={"col-12 option option-" + item[0]}>
              <div className="row">
                <div
                  className="col-sm-7"
                  style={{ background: "url(/img/" + item[2] + ")" }}
                ></div>
                <div className="col-sm-4 vcenter">
                  <div>
                    <h3>{item[1]}</h3>
                  </div>
                </div>
                <div className="col-sm-1 vcenter">
                  <div>
                    <input
                      type="radio"
                      name="experience"
                      checked={parseInt(experience, 10) === item[0]}
                      onChange={() => handleChange(item[0])}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        });
      } else {
        indents = myArr.map(function (item, i) {
          return (
            <div key={item[0]} className={"col-sm-4 option option-" + (i + 1)}>
              <div className="option-inner text-center">
                <h3>{item[1]}</h3>
                <span>{item[2]}</span>
                <div className="progress-icon text-left">
                  <img
                    className="img-responsive"
                    src="/img/bicycle.png"
                    style={{ left: item[3] - 10 + "%" }}
                    alt="Bicycle"
                  />
                </div>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-valuenow="20"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: item[3] + "%" }}
                  >
                    <span className="sr-only">{item[3]}% Complete</span>
                  </div>
                </div>
                <input
                  type="radio"
                  name="experience"
                  checked={parseInt(experience, 10) === item[0]}
                  onChange={() => handleChange(item[0])}
                />
              </div>
            </div>
          );
        });
      }
      return (
        <div className="container main">
          <Progress
            goTo={this.props.goTo}
            step={0}
            traject={this.props.traject}
          />

          <form className="row experience" onSubmit={this.handleSubmit}>
            <div className="col-12 text-center title">
              <h2>{this.props.t("experience title " + this.props.traject)}</h2>

              <span className="sub-title">
                {this.props.t("Expierence_PopupTitle")}
              </span>
            </div>

            {indents}
            <div className="col-12 text-right">
              <input
                id="submitbtn"
                className="btn btn-secondary"
                type="submit"
                value={this.props.t("Volgende")}
              />
            </div>
          </form>
        </div>
      );
    } else {
      return <Loader />;
    }
  }

  getExperience() {
    if (this.props.traject !== "bikefit") {
      Api.get("/experience", { bike_cat: this.props.traject }).then(
        response => {
          this.setState({ data: response.data });
        }
      );
    }
  }

  handleChange(value) {
    this.setState({ value: value });
    document.getElementById("submitbtn").disabled = false;
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.value === undefined) {
      alert(this.props.t("Please provide an answer"));
    } else {
      this.props
        .handler(this.state.value)
        .then(() =>
          this.props.goTo("/advice/parcour_type", this.props.traject)
        );
    }
  }

  goBack(event) {
    event.preventDefault();
    this.props.goTo("/advice/experience", this.props.traject);
  }
}

export default withTranslation("experience")(Experience);
